import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';
import { JwtService } from './jwt.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiService } from './api.service';
import { HttpHeaders } from '@angular/common/http';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ApiPaths } from '../Models/api-path';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private selectedClientIdSubject = new BehaviorSubject<number | null>(null);
  private selectedSupplierEPIdSubject = new BehaviorSubject<number | null>(null);
  selectedClientId$ = this.selectedClientIdSubject.asObservable();
  private selectedClientNameSubject = new BehaviorSubject<string>('');
  selectedClientName$ = this.selectedClientNameSubject.asObservable();
  private selectedClientUserIdSubject = new BehaviorSubject<string>('');
  selectedClientUserId$ = this.selectedClientUserIdSubject.asObservable();
  private selectedClientEpNameSubject = new BehaviorSubject<string>('');
  selectedClientEpNameSubject$ = this.selectedClientEpNameSubject.asObservable();
  selectedSClientId$ = this.selectedClientEpNameSubject.asObservable();
  url: string = '';
  token: any = '';
  userData: any = {};
  Permission:any=[];
  // This variable is used for dsl to link connectivity confirmation
  constructor(
    private jwtService: JwtService,
    private apiService: ApiService
  ) {
    this.token = jwtService.getToken();
  }

  setSelectedClientId(clientId: number) {
    this.selectedClientIdSubject.next(clientId);
  }

  setSelectedClientName(clientName: string) {
    this.selectedClientNameSubject.next(clientName);
  }

  setSelectedClientUserId(clientUserId: string) {
    this.selectedClientUserIdSubject.next(clientUserId);
  }

  setSelectedClientEpName(clientEpName: string) {
    this.selectedClientEpNameSubject.next(clientEpName);
  }
  setUserType(userType: string) {
    this.selectedClientEpNameSubject.next(userType);
  }
  
  setsupplierSelectedClientId(clientId: number) {
    this.selectedSupplierEPIdSubject.next(clientId);
  }
  convertDateIntoUtc(value:any) {
    return value ? moment.utc(value).format('YYYY-MM-DD HH:mm:ss') : '';
  }

  convertDateIntoUtcForSearch(value:any) {
    return value ? moment.utc(value).format('YYYY-MM-DD 23:59:59') : '';
  }

// Encryption method
encrypt(keys: string, value: string): string {
  const keySize = 256;
  const salt = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.PBKDF2(keys, salt, {
    keySize: keySize / 32,
    iterations: 100
  });

  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  const encrypted = CryptoJS.AES.encrypt(value, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC
  });

  const result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));

  return result;
}

// Decryption method
decrypt(keys: string, value: string): string {
  const key = CryptoJS.enc.Utf8.parse(keys);
  const iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
  const decrypted = CryptoJS.AES.decrypt(value, key, { iv: iv });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

// Check user permissions
hasPermission(button: string): boolean {
  this.Permission = this.jwtService.getPermissions();
  // Filter permissions based on the provided button
  const module: boolean =  this.Permission?.find((access:any) => access === button)!==undefined && this.Permission.find((access:any) => access === button)!==''?true:false;

  return module;
}
LoadAllState = (countryId: number) => {
  const localurl = ApiPaths.state.Search(countryId);
  return this.apiService.get(localurl,undefined,false);
}

LoadAllCity = (countryId: number, stateId: number) => {
  const localurl = ApiPaths.city.Search(countryId,stateId);
  return this.apiService.get(localurl, undefined, false)
}

//busissnesunit
GetBusinessUnitByID(Id: number): Observable<any> {
  const localurl =  ApiPaths.businessUnit.getById(Id);
  return this.apiService.get(localurl);
}
DeleteBusinessUnit(Id: number): Observable<any> {
  const deleteVM = {
    Id : Id
  }
  const localurl = ApiPaths.businessUnit.delete;
  return this.apiService.post(localurl, deleteVM);
}
addUpdateBusinessUnitCenter(body: any): Observable<any> {
  const localurl = ApiPaths.businessUnit.addUpdate;
  return this.apiService.post(localurl,body);
}
getBusinessUnitList(commonVM : any): Observable<any> {
  const localurl = ApiPaths.businessUnit.getBusinessUnitList;
  return this.apiService.post(localurl, commonVM,false);
}
//Employee

GetEmployeeByID(Id: number): Observable<any> {
  const localurl = ApiPaths.employee.getById(Id);
  return this.apiService.get(localurl,undefined,false);
}

DeleteEmployee(Id: number): Observable<any> {
  const deleteVM = {
    Id : Id
  }
  const localurl = ApiPaths.employee.delete;
  return this.apiService.post(localurl,deleteVM);
}
addUpdateEmployee(body: any): Observable<any> {
  const localurl = ApiPaths.employee.addUpdateManager;
  return this.apiService.post(localurl,body);
}
RegisterUser(data: any) {
  const localurl = ApiPaths.employee.addUpdate;
  return this.apiService.post(localurl, data);
}
getEmployeeList(searchVM : any): Observable<any> {
  const localurl = ApiPaths.employee.getListBySearch;
  return this.apiService.post(localurl, searchVM);
}

getHiringList(searchVM : any): Observable<any> {
  const localurl = ApiPaths.employee.getListBySearch;
  return this.apiService.post(localurl, searchVM, false);
}
//cost center
GetCostCenterByID(Id: number): Observable<any> {
  const localurl = ApiPaths.costCenter.getById(Id);
  return this.apiService.get(localurl);
}
DeleteCostCenter(Id: number): Observable<any> {
  const deleteVM = {
    Id : Id
  }
  const localurl = ApiPaths.costCenter.delete;
  return this.apiService.post(localurl,deleteVM);
}
addUpdateCostCenter(body: any): Observable<any> {
  const localurl = ApiPaths.costCenter.addUpdate;
  return this.apiService.post(localurl,body);
}
getCostCenterList(searchVm : any): Observable<any> {
  const localurl = ApiPaths.costCenter.getListBySearch;
  return this.apiService.post(localurl, searchVm, false);
}

//location
GetEPLocationByID(Id: number): Observable<any> {
  const localurl = ApiPaths.location.getById(Id);
  return this.apiService.get(localurl);
}
DeleteEPLocation(Id: number): Observable<any> {
  const deleteVM = {
    Id : Id
  }
  const localurl = ApiPaths.location.delete;
  return this.apiService.post(localurl,deleteVM);
}
addUpdateEPLocation(body: any): Observable<any> {
  const localurl = ApiPaths.location.addUpdate;
  return this.apiService.post(localurl,body);
}
getEPLocationList(searchVm : any): Observable<any> {
  const localurl = ApiPaths.location.getListBySearch;
  return this.apiService.post(localurl, searchVm, false);
}

getManagerList(search:string, epId: any, BuId: any, CcId: any): Observable<any> {
  const ManagerVM = {
  Search : search,
  EPId : epId,
  BuId : BuId,
  CcId : CcId
  }
  const localurl = ApiPaths.employee.getManager;
  return this.apiService.post(localurl, ManagerVM, false);
}

trimFormValues(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(controlName => {
    const control = formGroup.get(controlName);

    if (control instanceof FormGroup) {
      this.trimFormValues(control);
    } else {
      if (typeof control?.value === 'string') {
        control.setValue(control.value.trim());
      }
    }
  });
}

formatDate(dateString: string): string {
  if(dateString != null){
  const date = new Date(dateString);
  const datePipe = new DatePipe('en-US');
  const formattedDate = datePipe.transform(date, environment.commonSetting.dtFormat) ?? '';
  return formattedDate;
}
return '';
}

onOptionSelectedCountry(event: any, countryList: any[], countryIdControl: AbstractControl, countryNameControl: AbstractControl) {
  const selectedOption = countryList.find((option: { countryId: any; }) => option.countryId === event.option.id);
  if (selectedOption) {
    countryIdControl.setValue(selectedOption.countryId);
    countryNameControl.setValue(selectedOption.countryName);
  }
}

onOptionSelectedCountryFormModel(event: any, countryList: any[], formModel: any) {
  const selectedOption = countryList.find((option: { countryId: any; }) => option.countryId === event.option.id);
  if (selectedOption) {
    formModel.CountryId = selectedOption.countryId;
    formModel.CountryName = selectedOption.countryName;
  }
}

onOptionSelectedState(event: any, stateList: any[], stateIdControl: AbstractControl, stateNameControl: AbstractControl) {
  const selectedOption = stateList.find((option: { stateId: any; }) => option.stateId === event.option.id);
  if (selectedOption) {
    stateIdControl.setValue(selectedOption.stateId);
    stateNameControl.setValue(selectedOption.stateName);
  }
}

clearFieldIfIdNotPresent(idControl: AbstractControl, nameControl: AbstractControl) {
  if (!idControl.value){
    nameControl.setValue('');
  }
}

clearFieldsIfIdNotSelected(
  formGroup: FormGroup,
  idField: string,
  nameField: string
): void {
  const nameValue = formGroup.get(nameField)?.value;
  const idValue = formGroup.get(idField)?.value;

  if (nameValue && !idValue) {
    formGroup.patchValue({
      [nameField]: '',
      [idField]: ''
    });
  }
}

clearFieldsIfIdNotSelectedInObject(
  formObject: any,
  idField: string,
  nameField: string
): void {
  const nameValue = formObject[nameField];
  const idValue = formObject[idField];

  if (nameValue && !idValue) {
    formObject[nameField] = '';
    formObject[idField] = '';
  }
}


onOptionSelectedStateFormModel(event: any, stateList: any[], formModel: any) {
  const selectedOption = stateList.find((option: { stateId: any; }) => option.stateId === event.option.id);
  if (selectedOption) {
    formModel.StateId = selectedOption.stateId;
    formModel.StateName= selectedOption.stateName;
  }
}

getStateNameById(stateList: any[], stateId: string): string {
  const state = stateList?.find((c: { stateId: string; }) => c.stateId === stateId);
  return state ? state.stateName : '';
}

getCountryNameById(countryList: any[], countryId: string): string {
  const country = countryList?.find((c: { countryId: string; }) => c.countryId === countryId);
  return country ? country.countryName : '';
}

filterList(list: any[], originalList: any[], searchKey: string, fieldName: string): any[] {
  const searchValue = searchKey.toLowerCase();
  return originalList.filter((item: any) =>
    item[fieldName].toLowerCase().toString().startsWith(searchValue)
  );
}

filterListFormModel(originalList: any[], searchKey: string, fieldName: string): any[] {
  const searchValue = searchKey.toLowerCase();
  return originalList.filter((item: any) => {
    const fieldValue = item[fieldName]?.toString().toLowerCase();
    return fieldValue.startsWith(searchValue);
  });
}
SaveLog(data: object | undefined): Observable<any> {
  const localurl =ApiPaths.Logger.addUpdate;
  return this.apiService.post(localurl,data);
}
}
